<template>
  <div>
    <div>
      <router-view/>
    </div>
  </div>

</template>

<script>
  export default {
    created() {
      this.$store.dispatch('GET_ONE_AUTHOR', this.$route.params.authorid);
      this.$store.dispatch('GET_INSTITUTES', this.$route.params.authorid);
    }
  }
</script>

